import { type AxiosError } from 'axios';
import { logger } from '@/infra/logging';
import type { RetryableRequestConfig } from '../../api.types';

export function logFailedRequest(
  error: AxiosError,
  originalRequest: RetryableRequestConfig,
  status?: number
): void {
  logger.error('API request failed', error, {
    component: 'ApiClient.ResponseInterceptor',
    status,
    url: originalRequest?.url,
    method: originalRequest?.method?.toUpperCase(),
  });
}
